import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Switch from 'components/Switch/Switch';

import styles from './SwitchActionItem.css';


const SwitchActionItem = ({
  label,
  labelClassName,
  switchProps,
  wrapperClassName,
}) => (
  <div className={classNames([styles.itemWrapper, wrapperClassName])}>
    <div className={classNames(labelClassName)}>
      {label}
    </div>
    <Switch color="default" {...switchProps} />
  </div>
);

SwitchActionItem.propTypes = {
  label: PropTypes.object,
  labelClassName: PropTypes.string,
  switchProps: PropTypes.object,
  wrapperClassName: PropTypes.string,
};

SwitchActionItem.defaultProps = {
  labelClassName: undefined,
  label: {},
  switchProps: {},
  wrapperClassName: undefined,
};

export default SwitchActionItem;
